import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.activeProductionOrders.components';

export default defineMessages({

    dialogheadding: {
        id: `${scope}.label.dialogheadding`,
        defaultMessage: 'Active production order details for machine ',
    },
    activeProductionOrderNumberLabel: {
        id: `${scope}.label.activeProductionOrderNumber`,
        defaultMessage: 'Active production order number',
    },
    allItemsLabel: {
        id: `${scope}.label.allItems`,
        defaultMessage: 'All items',
    },
    activeItemLabel: {
        id: `${scope}.label.activeItem`,
        defaultMessage: 'Active item',
    },
    activeToolLabel: {
        id: `${scope}.label.activeTool`,
        defaultMessage: 'Active tool',
    },
    idealCycleTimeLabel: {
        id: `${scope}.label.idealCycleTime`,
        defaultMessage: 'Ideal cycle time',
    },
    plannedQuantityLabel: {
        id: `${scope}.label.plannedQuantity`,
        defaultMessage: 'Planned quantity',
    },
    reportedQuantityLabel: {
        id: `${scope}.label.reportedQuantity`,
        defaultMessage: 'Reported quantity',
    },
    remainingQuantityLabel: {
        id: `${scope}.label.remainingQuantity`,
        defaultMessage: 'Remaining quantity',
    },
    cavitiesLabel: {
        id: `${scope}.label.cavities`,
        defaultMessage: 'Cavities',
    },
    buttonDeleteOrderLabel: {
        id: `${scope}.label.buttonDeleteOrder`,
        defaultMessage: 'End order',
    },
    buttonCreateOrderLabel: {
        id: `${scope}.label.buttonCreateOrder`,
        defaultMessage: 'Create order',
    },
    no: {
        id: `${scope}.label.no`,
        defaultMessage: 'No',
    },
    yes: {
        id: `${scope}.label.yes`,
        defaultMessage: 'Yes',
    },
    deleteActiveProductionOrderTitle: {
        id: `${scope}.label.deleteActiveProductionOrderTitle`,
        defaultMessage: 'Delete active production order',
    },
    deleteActiveProductionOrderMessage: {
        id: `${scope}.label.deleteActiveProductionOrderMessage`,
        defaultMessage: 'Do you want to delete the active production order',
    },
    buttonUpdateOrderLabel: {
        id: `${scope}.label.buttonUpdateOrder`,
        defaultMessage: 'Update order',
    },


    machineLabel: {
        id: `${scope}.label.machine`,
        defaultMessage: 'Machine',
    },
    productionOrderLabel: {
        id: `${scope}.label.productionOrder`,
        defaultMessage: 'Production order',
    },
    itemLabel: {
        id: `${scope}.label.item`,
        defaultMessage: 'Item',
    },



    editProductionItemLabel: {
        id: `${scope}.label.editProductionItem`,
        defaultMessage: 'Edit production item',
    },
    deleteProductionItemLabel: {
        id: `${scope}.label.deleteProductionItem`,
        defaultMessage: 'Delete production item',
    },

    startLabel: {
        id: `${scope}.label.start`,
        defaultMessage: 'Start',
    },
    reportLabel: {
        id: `${scope}.label.report`,
        defaultMessage: 'Report',
    },
    stopLabel: {
        id: `${scope}.label.stop`,
        defaultMessage: 'Stop',
    },

    cycleTimeWarningLabel: {
        id: `${scope}.label.cycleTimeWarning`,
        defaultMessage: 'Default cycle time for item differs from the stated value. Default cycletime is:',
    },
    cavityWarningLabel: {
        id: `${scope}.label.cavityWarning`,
        defaultMessage: 'Default amount/cycle for item differs from the stated value. Default amount/cycle is:',
    },
    requiredFieldsMessage: {
        id: `${scope}.label.requiredFieldsMessage`,
        defaultMessage: 'Please fill in all required fields: ',
    },
    orderDeletedMessage: {
        id: `${scope}.label.orderDeletedMessage`,
        defaultMessage: 'Active production order stopped successfully.',
    },
    orderUpdatedMessage: {
        id: `${scope}.label.orderUpdatedMessage`,
        defaultMessage: 'Active production order updated successfully.',
    },
    orderCreatedMessage: {
        id: `${scope}.label.orderCreatedMessage`,
        defaultMessage: 'Active production order started successfully.',
    },
    activeProductionOrderRestartMessage: {
        id: `${scope}.label.activeProductionOrderRestartMessage`,
        defaultMessage: 'This machine has an ongoing production order. By starting a new one, the ongoing order will be stopped!',
    },

});